__turbopack_context__.v({
  "disclaimerLogo": "headers-module-scss-module__Zgu_1G__disclaimerLogo",
  "disclaimerLogoOnTop": "headers-module-scss-module__Zgu_1G__disclaimerLogoOnTop",
  "isH1": "headers-module-scss-module__Zgu_1G__isH1",
  "isH2": "headers-module-scss-module__Zgu_1G__isH2",
  "isH3": "headers-module-scss-module__Zgu_1G__isH3",
  "logoWrapper": "headers-module-scss-module__Zgu_1G__logoWrapper",
});
